import { DynamicAudience } from 'src/generated/mloop-graphql';

/**
 * An opt-in action rendered inside a selected chip.
 *
 * `SmartEmployeeSelect` has many callers (CC/BCC, Slack members, interview-plan options, …) and
 * none of them want an extra control on their chips, so this is passed only by the
 * additional-attendee surfaces. A caller that passes nothing gets exactly the chips it has today.
 */
export type SmartEmployeeSelectChipAction = {
  isOptional: boolean;
  onToggle: () => void;
};

/**
 * Returns the action for one chip, or `undefined` for a chip that should not carry one. Keys are
 * the same stable recipient identities the attendee entries use (`employee:<id>`,
 * `email:<lowercased>`), plus `audience:<AUDIENCE>` for the settings surfaces where an audience
 * itself carries a role.
 */
export type GetSmartEmployeeSelectChipAction = (chipKey: string) => SmartEmployeeSelectChipAction | undefined;

export const employeeChipKey = (employeeId: string): string => `employee:${employeeId}`;
export const emailChipKey = (email: string): string => `email:${email.trim().toLowerCase()}`;
export const audienceChipKey = (audience: DynamicAudience): string => `audience:${audience}`;
